module.exports = __webpack_public_path__ + "1565634e93958efe195ebe78143af61b.jpg";